var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6a6 6 0 1 0-9 5.197V15l1 1h4l1-1v-3.803A6 6 0 0 0 14 6m-4.5 7h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5m.5-2.415V6a1 1 0 1 0-1-1v5.9a5 5 0 0 1-2 0V5a1 1 0 1 0-1 1v4.585a5 5 0 0 1-1.536-1.05C3.52 8.591 3 7.335 3 5.999s.52-2.591 1.464-3.536S6.664.999 8 .999s2.591.52 3.536 1.464S13 4.663 13 5.999s-.52 2.591-1.464 3.536c-.45.45-.97.803-1.536 1.05M9.5 15h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tip.svg";